import { Navigate, Route, Routes } from 'react-router'
import { AuthProvider, useMe } from './lib/auth'
import { Notice, Spinner } from './components/ui'
import Layout from './components/Layout'
import Login from './pages/Login'
import ChangePassword from './pages/ChangePassword'
import Dashboard from './pages/Dashboard'
import ContentList from './pages/ContentList'
import ContentEdit from './pages/ContentEdit'
import SettingsPage from './pages/Settings'
import MediaPage from './pages/Media'
import Users from './pages/Users'
import PublishHistory from './pages/PublishHistory'

export default function App() {
  const me = useMe()

  if (me.isPending) {
    return (
      <div className="grid min-h-screen place-items-center text-muted">
        <Spinner className="h-6 w-6" />
      </div>
    )
  }
  if (me.isError) {
    return <div className="mx-auto mt-20 max-w-md"><Notice>Could not reach the CMS: {String(me.error)}</Notice></div>
  }
  if (!me.data) return <Login />

  return (
    <AuthProvider user={me.data}>
      {me.data.mustChangePassword ? (
        <ChangePassword forced />
      ) : (
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="content/settings" element={<SettingsPage />} />
            <Route path="content/:type" element={<ContentList />} />
            <Route path="content/:type/new" element={<ContentEdit />} />
            <Route path="content/:type/:id" element={<ContentEdit />} />
            <Route path="media" element={<MediaPage />} />
            <Route path="publish" element={<PublishHistory />} />
            <Route path="account" element={<ChangePassword />} />
            {me.data.role === 'admin' && <Route path="users" element={<Users />} />}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      )}
    </AuthProvider>
  )
}
